import { render, staticRenderFns } from "./RenderBlocks.vue?vue&type=template&id=4e98514c&scoped=true&"
import script from "./RenderBlocks.vue?vue&type=script&lang=js&"
export * from "./RenderBlocks.vue?vue&type=script&lang=js&"
import style0 from "./RenderBlocks.vue?vue&type=style&index=0&id=4e98514c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98514c",
  null
  
)

export default component.exports